import Time from 'model/appointments/timeSlots/time'
import { isNil } from 'ramda'
import { PENDING } from 'constants/appointments'

class Pending extends Time {
  constructor(init) {
    super(init)
    // console.log('> Pending constructor -', init)
    if (isNil(init)) return undefined
  }

  // Calculable
  get isPending() {
    return this.__typename === PENDING
  }
}

export default Pending
